var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('case-container',[_c('selected-categories'),_c('available-categories')],1)}
var staticRenderFns = []

export { render, staticRenderFns }